import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBudgetTabContext } from '../../contexts/BudgetTabContext';
import BudgetTable from '../Budget/BudgetTable/BudgetTable';
import Financial from '../Financial/Financial';
import Analysis from '../Analysis/Analysis';

const BudgetContainer: React.FC = () => {
  const navigate = useNavigate();
  const { budgetId, activeTab } = useBudgetTabContext();
  
  // 如果没有 budgetId，重定向到主页
  useEffect(() => {
    if (!budgetId) {
      navigate('/', { replace: true });
    }
  }, [budgetId, navigate]);

  // 如果没有 budgetId，不渲染任何内容（等待重定向）
  if (!budgetId) {
    return null;
  }

  // 根据激活标签渲染对应的组件
  // 使用条件渲染但保持组件挂载，避免重新加载
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div style={{ display: activeTab === 'budget' ? 'block' : 'none', width: '100%', height: '100%' }}>
        <BudgetTable budgetId={budgetId} />
      </div>
      <div style={{ display: activeTab === 'financial' ? 'block' : 'none', width: '100%', height: '100%' }}>
        <Financial budgetId={budgetId} />
      </div>
      <div style={{ display: activeTab === 'analysis' ? 'block' : 'none', width: '100%', height: '100%' }}>
        <Analysis budgetId={budgetId} />
      </div>
    </div>
  );
};

export default BudgetContainer;
